import { DropzoneInputProps, DropzoneRootProps } from "react-dropzone";

import { AccordionKey, DropZoneUploadButton } from "@shared";

import { DocumentGroup, DocumentResponse } from "@/api";
import { FileActions } from "@/common/components/layout/components/dropzone/DropZone.types";
import { BulkActionBar } from "@/common/components/layout/components/dropzone/components/bulk-action-bar/BulkActionBar";
import { PendingDocumentMove } from "@/common/components/layout/components/dropzone/dnd/DropZoneDnd.types";

import { DropzoneAccordion } from "../dropzone-accordion/DropzoneAccordion";
import { DocumentList } from "./components/document-list/DocumentList";

interface Props {
  title: string;
  accordionKey: AccordionKey;
  getRootProps: <T extends DropzoneRootProps>(props?: T) => T;
  isDragActive: boolean;
  getInputProps: <T extends DropzoneInputProps>(props?: T) => T;
  files: DocumentResponse[];
  uploadingFiles: File[];
  pendingIncomingMoves: PendingDocumentMove[];
  selectedFiles: Set<string>;
  onToggleSelect: (fileId: string) => void;
  fileActions: FileActions;
  onBulkDownload: () => void;
  onBulkDelete: () => void;
  onBulkMerge?: () => void;
  isBulkActionPending?: boolean;
  sourceZone: DocumentGroup;
}

export function DropZoneSection({
  title,
  accordionKey,
  files,
  uploadingFiles,
  pendingIncomingMoves,
  selectedFiles,
  onToggleSelect,
  fileActions,
  onBulkDownload,
  onBulkDelete,
  onBulkMerge,
  isBulkActionPending,
  getInputProps,
  getRootProps,
  isDragActive,
  sourceZone,
}: Props) {
  return (
    <DropzoneAccordion title={title} zoneId={sourceZone} accordionKey={accordionKey}>
      <DocumentList
        files={files}
        uploadingFiles={uploadingFiles}
        pendingIncomingMoves={pendingIncomingMoves}
        selectedFiles={selectedFiles}
        onToggleSelect={onToggleSelect}
        fileActions={fileActions}
        sourceZone={sourceZone}
      />
      <BulkActionBar
        selectedCount={selectedFiles.size}
        onDownload={onBulkDownload}
        onDelete={onBulkDelete}
        onMerge={onBulkMerge}
        disabled={isBulkActionPending}
      />
      <DropZoneUploadButton isDragActive={isDragActive} getInputProps={getInputProps} getRootProps={getRootProps} />
    </DropzoneAccordion>
  );
}
